import { Map } from 'immutable'
import { SET_LOCATION_DATA } from './actions'

export const initialState = Map()

export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case SET_LOCATION_DATA: {
      let { data } = payload
      if (!Map.isMap(data)) {
        const {
          hostname, query, search, hash, pathname, path, href,
        } = data
        data = Map({
          hostname, query: Map(query), search, hash, pathname, path, href,
        })
      }
      return state.set('data', data)
    }
    default:
      return state
  }
}
